import request from '@/utils/request'

/**
 * 获取业务数据总线列表
 * @param {Object} params 查询参数
 * @returns {Promise} 请求Promise
 */
export function listBusinessDatabus(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/databus.listBusinessDatabus',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 新增业务数据总线
 * @param {Object} data 业务数据总线数据
 * @returns {Promise} 请求Promise
 */
export function saveBusinessDatabus(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/databus.saveBusinessDatabus',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新业务数据总线
 * @param {Object} data 业务数据总线数据
 * @returns {Promise} 请求Promise
 */
export function updateBusinessDatabus(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/databus.updateBusinessDatabus',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除业务数据总线
 * @param {Object} data 业务数据总线数据
 * @returns {Promise} 请求Promise
 */
export function deleteBusinessDatabus(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/databus.deleteBusinessDatabus',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}